<template>
	<tr class="tableTr" :key="item.id">
		<td width="100">{{ item['invoice_id'] }}</td>
		<td width="300">{{ item['name'] }}</td>
		<td width="80">{{ item['amount'] }}</td>
		<td>
		  <field
				  :class-error="valid.selectedInvoices && valid.selectedInvoices.$each.$iter[idx].$error"
				  margin="0"
				  width="100%"
				  placeholder="Enter email"
				  :setInputValue="item['email']"
				  @updateInput="onInput"
				  :idx="idx"
				  is-off-style
		      icon="edit"
		  ></field>
		</td>
		<td>
			<div class="center">
				<svg-sprite v-if="isSms" width="20" height="20" icon-id="ok"></svg-sprite>
				<svg-sprite v-else width="20" height="20" icon-id="close"></svg-sprite>
			</div>
		</td>
		<td width="100" class="center btn" :class="{'disabled': !item['file']}">
				<button :disabled="!item['file']" @click="onView(item['file'])">
						<svg-sprite width="20" height="20" icon-id="eye"></svg-sprite>
				</button>
		</td>
		<td width="100" class="center btn" :class="{'disabled': !item['file_report']}">
			<button :disabled="!item['file_report']" @click="onView(item['file_report'])">
				<svg-sprite width="20" height="20" icon-id="eye"></svg-sprite>
			</button>
		</td>
	  <td width="100" class="center btn" :class="{'disabled': !item['file_report_safety']}">
		  <button :disabled="!item['file_report_safety']" @click="onView(item['file_report_safety'])">
			  <svg-sprite width="20" height="20" icon-id="eye"></svg-sprite>
		  </button>
	  </td>
	  <td width="100" class="center btn" :class="{'disabled': !item['file_report_billing']}">
		  <button :disabled="!item['file_report_billing']" @click="onView(item['file_report_billing'])">
			  <svg-sprite width="20" height="20" icon-id="eye"></svg-sprite>
		  </button>
	  </td>
	</tr>
</template>

<script>
// services

export default {
	name: "TableTr",
	props: {
		checkClasses: Object,
		item: Object,
		valid: Object,
		idx: Number,
		isHideFile: Boolean,
		isSms: Boolean,
	},
	methods: {
		onView(file) {
			this.$store.dispatch('onPreview', file);
		},
		onInput({ value, idx }) {
			console.info('%c test', 'color: #FFB02E', { value, idx });
			this.$set(this.item, 'email', value);
		}
	}
};
</script>

<style scoped lang="scss">
@import "TableTr";
</style>

